import store from 'app-store';
import history from 'app-history';
import _ from 'lodash';
import { SET_LOCATION } from './action-types';

// Action creators
export function setLocation(location) {
  store.dispatch({ type: SET_LOCATION, location });
}

export function mergeQuery(merge, deep) {
  const { query: currentQuery, pathname } = store.getState().location;
  const fn = deep ? _.defaultsDeep : _.defaults;
  const query = fn({}, merge, currentQuery);

  history.push({ pathname, query });
}

export function mergeQueryReplace(merge) {
  const { query: currentQuery, pathname } = store.getState().location;
  // Always set setDefaultQuery to false when updating history, because we only ever
  // want to update the default query once and don't want to get stuck in an infinite
  // loop of setting it
  const query = _.assign({}, currentQuery, merge);
  delete query.setDefaultQuery;

  history.replace({ pathname, query });
}

history.listen(setLocation);



// WEBPACK FOOTER //
// ./app/modules/history/actions.js